export default __webpack_public_path__ + "static/media/dk.3754fa6c.svg";